import { ArrayDataSource } from './BaseDataSources';
import { IVendorReviewType } from '../Interfaces';

export class ReviewVendorSource extends ArrayDataSource<IVendorReviewType> {
  public constructor(id: string) {
    super('/datasource/reviewvendors', { id });
  }
}